import { DataTableItem } from "./types";
import { getFormatDate } from "~/libs/getFormatDate";

export const transformDataTable = (dataItems: DataTableItem[]) => {
  if (!dataItems || !Array.isArray(dataItems)) {
    return [];
  }

  return dataItems.map((item: DataTableItem) => {
    const { File, InformationSystem, createdAt, updatedAt } = item;

    return {
      ...item,
      personalDataTemplate: File && File.id,
      informationSystem: InformationSystem && InformationSystem.name,
      createdAt: getFormatDate(createdAt),
      updatedAt: getFormatDate(updatedAt),
    };
  });
};
